import { Navigate, Outlet } from 'react-router';

import { useStaffSession } from '@/components/auth/staff-session-provider';

/**
 * Route guard for platform administration.
 * Checks the effective role so a super-admin who is acting as a lower role
 * must deliberately return to their real role before accessing this area.
 */
export function RequireAdmin() {
  const { loading, staffRole } = useStaffSession();

  if (loading) return null;

  if (staffRole !== 'super_admin') {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
